// @ts-nocheck
import styled from 'styled-components';

export const MapInnerControlsStyle = styled.div`
  .mapboxgl-ctrl {
    z-index: 3;
  }
  .switchButtonGroup__panelBody {
    overflow: visible
  }
  .singleSelectorComponent__menu-list {
    max-height: 150px;
  }

  .mapInnerControls {
    &__mapView {
      .switchButtonGroup__panel {
        max-height: 404px;
      }
      .switchButtonGroup__panelBody {
        overflow: auto;
      }
    }
    &__cartographyFilter {
      .switchButtonGroup__panel {
        width: 272px;
      }
    }
    &__section {
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding-bottom: 10px;
      &__description {
        color: ${props => props.theme.uiColors.selectorDescription};
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
      }
    }
  }
`;
